import template from './index.pug'

// @vue/component
export default {
  name: 'email-confirmation',
  template: template(),
  data() {
    return {
      status: 'loading',
      email: '',
      confirmationRequest: undefined,
      resendError: undefined,
      resendLoading: false,
      resendSuccess: undefined
    }
  },
  computed: {
    confirmationToken() {
      return this.$route?.query?.confirmation_token || this.$route?.query?.token
    },
    isError() {
      return ['expired', 'invalid', 'providerError', 'disabled', 'error'].includes(this.status)
    },
    showResultModal() {
      return this.status !== 'loading'
    },
    canResend() {
      return ['providerError', 'error'].includes(this.status)
    }
  },
  watch: {
    status() {
      this.focusStatusHeading()
    }
  },
  created() {
    this.confirm()
  },
  mounted() {
    this.focusStatusHeading()
  },
  methods: {
    focusStatusHeading() {
      this.$nextTick(() => {
        this.$refs.statusHeading?.focus()
      })
    },

    confirm() {
      if (this.confirmationRequest) return this.confirmationRequest

      this.status = 'loading'
      this.resendError = undefined
      this.resendSuccess = undefined

      if (!this.confirmationToken) {
        this.status = 'invalid'

        return Promise.resolve()
      }

      this.confirmationRequest = this.$auth.confirmEmail(this.confirmationToken)
        .then(response => {
          if (response?.status !== 204) {
            this.status = 'error'

            return
          }

          this.$auth.resetLocalSession()
          this.status = 'success'
        })
        .catch(error => this.handleConfirmationError(error))

      return this.confirmationRequest
    },

    handleConfirmationError(error) {
      const errors = error?.data?.errors || error?.response?.data?.errors
      const code = errors?.[0]?.code || errors?.code

      if (code === 'REGISTER_CONFIRMATION_TOKEN_EXPIRED') {
        this.status = 'expired'

        return
      }

      if (code === 'REGISTER_CONFIRMATION_TOKEN_INVALID') {
        this.status = 'invalid'

        return
      }

      if (code === 'REGISTER_CONFIRMATION_PROVIDER_ERROR') {
        this.status = 'providerError'

        return
      }

      if (code === 'CLIENT_EMAIL_CHANGE_DISABLED') {
        this.status = 'disabled'

        return
      }

      this.status = 'error'
    },

    resendConfirmation() {
      if (this.resendLoading) return Promise.resolve()

      if (!this.email) {
        this.resendError = this.$t('emailConfirmation.emailRequired')

        return Promise.resolve()
      }

      this.resendLoading = true
      this.resendError = undefined
      this.resendSuccess = undefined

      return this.$auth.resendConfirmation(this.email)
        .then(() => {
          this.resendSuccess = this.$t('emailConfirmation.resendSuccess')
        })
        .catch(() => {
          this.resendError = this.$t('emailConfirmation.resendError')
        })
        .finally(() => {
          this.resendLoading = false
        })
    },

    goToLogin() {
      this.$router.replace({name: 'home', query: {openLogin: 1}})
    }
  }
}
